"use client";

import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VacavilleHq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const hours = [{
    days: "MON-FRI",
    time: "08:00-18:00"
  }, {
    days: "SAT",
    time: "10:00-14:00"
  }, {
    days: "SUN",
    time: "CLOSED"
  }];
  const mapEmbedUrl = "https://www.openstreetmap.org/export/embed.html?bbox=-122.00%2C38.34%2C-121.95%2C38.37&layer=mapnik&marker=38.3595%2C-121.9707";
  return <section data-section-id="2485" id="vacaville-hq" ref={ref} className="relative bg-background text-foreground border-t border-border">
      <div className="relative w-full h-[600px] max-h-[100vh] overflow-hidden">
        {}
        <div className="hidden md:block absolute inset-0">
          <iframe src={mapEmbedUrl} className="w-full h-full grayscale contrast-125 brightness-50 invert" style={{
          border: 0,
          filter: "invert(1) hue-rotate(180deg) grayscale(0.8) contrast(1.1) brightness(0.9)"
        }} loading="lazy" title="AI Guyz Headquarters Location Map" />
          {}
          <div className="absolute inset-0 bg-background/40 pointer-events-none" />

          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
            <div className="relative flex items-center justify-center">
              <span className="absolute inline-flex h-16 w-16 rounded-lg bg-primary/30 animate-ping" />
              <span className="absolute inline-flex h-10 w-10 rounded-lg bg-primary/50" />
              <span className="relative inline-flex h-6 w-6 rounded-lg bg-primary border-2 border-background shadow-lg items-center justify-center">
                <MapPin className="h-3 w-3 text-primary-foreground" strokeWidth={3} />
              </span>
            </div>
          </div>

          {}
          <div className={`absolute bottom-12 left-12 z-10 max-w-[380px] w-full transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="bg-card border border-border p-8 rounded-lg shadow-lg">
              
              <h2 className="font-default text-2xl font-semibold tracking-tight mb-4 text-card-foreground">
                Vacaville, California.
              </h2>
              
              <div className="h-px w-full bg-border mb-6" />
              <div className="flex flex-col gap-3">
                
                <Link to="#" className="group font-mono text-xs uppercase tracking-widest text-card-foreground hover:text-primary transition-colors flex items-center justify-between">
                  
                  
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className={`absolute top-12 right-12 z-10 transition-all duration-700 delay-150 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"}`}>
            
          </div>
        </div>

        {}
        <div className="md:hidden absolute inset-0">
          <iframe src={mapEmbedUrl} className="w-full h-full" style={{
          border: 0,
          filter: "invert(1) hue-rotate(180deg) grayscale(0.8) contrast(1.1) brightness(0.9)"
        }} loading="lazy" title="AI Guyz Headquarters Location Map" />
          <div className="absolute inset-0 bg-background/40 pointer-events-none" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
            <div className="relative flex items-center justify-center">
              <span className="absolute inline-flex h-12 w-12 rounded-lg bg-primary/30 animate-ping" />
              <span className="absolute inline-flex h-8 w-8 rounded-lg bg-primary/50" />
              <span className="relative inline-flex h-5 w-5 rounded-lg bg-primary border-2 border-background shadow-lg items-center justify-center">
                <MapPin className="h-3 w-3 text-primary-foreground" strokeWidth={3} />
              </span>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="md:hidden px-6 py-10 flex flex-col gap-6 border-t border-border">
        <div className="bg-card border border-border p-6 rounded-lg shadow-md">
          <div className="font-mono text-xs uppercase tracking-widest text-primary mb-4">
            02 / VISIT OUR HQ
          </div>
          <h2 className="font-default text-2xl font-semibold tracking-tight mb-4 text-card-foreground">
            Vacaville, California.
          </h2>
          <address className="not-italic font-default text-[0.95rem] leading-relaxed text-card-foreground/85 mb-5">
            Main Operations Center
            <br />
            Vacaville, CA 95688
            <br />
            United States
          </address>
          <div className="h-px w-full bg-border mb-5" />
          <div className="flex flex-col gap-3">
            <Link to="https://www.openstreetmap.org/?mlat=38.3595&mlon=-121.9707#map=16/38.3595/-121.9707" newTab className="group font-mono text-xs uppercase tracking-widest text-card-foreground hover:text-primary transition-colors flex items-center justify-between">
              <span>GET DIRECTIONS</span>
              <ArrowRight className="h-4 w-4 text-primary transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <Link to="#" className="group font-mono text-xs uppercase tracking-widest text-card-foreground hover:text-primary transition-colors flex items-center justify-between">
              <span>BOOK A CONSULT</span>
              <ArrowRight className="h-4 w-4 text-primary transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        <div className="bg-card border border-border p-6 rounded-lg shadow-md">
          <div className="font-mono text-xs uppercase tracking-widest text-primary mb-4">
            OPERATING HOURS
          </div>
          <table className="w-full font-mono text-xs">
            <tbody>
              {hours.map((row, i) => <tr key={i} data-index={i} className="border-b border-border last:border-b-0">
                  <td className="py-2 uppercase tracking-wider text-card-foreground/70">
                    {row.days}
                  </td>
                  <td className="py-2 uppercase tracking-wider text-right text-card-foreground">
                    {row.time}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <Button asChild className="font-mono text-xs uppercase tracking-widest rounded-lg">
          <Link to="#">Book A Consult</Link>
        </Button>
      </div>
    </section>;
}